import { render, staticRenderFns } from "./learn.math.task.vue?vue&type=template&id=ea0a86a0&scoped=true&"
import script from "./learn.math.task.vue?vue&type=script&lang=ts&"
export * from "./learn.math.task.vue?vue&type=script&lang=ts&"
import style0 from "./learn.math.task.vue?vue&type=style&index=0&id=ea0a86a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0a86a0",
  null
  
)

export default component.exports